var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._b({class:_vm.$style.remove,attrs:{"icon":"","dense":"","color":"primary"},on:{"click":function($event){return _vm.$emit('delete')}}},'v-btn',_vm.$attrs,false),[_c('IconSelect',{class:_vm.$style['trash-icon'],attrs:{"icon":"trash","height":_vm.defaultIconSize,"width":_vm.defaultIconSize}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }